<script setup lang="ts">
import HeadingSmall from "@/components/HeadingSmall.vue"
import { Card, CardContent } from "@/components/ui/card"

import LabelledItem from "./InsuranceLabelledItem.vue"
</script>

<template>
  <Card>
    <CardContent>
      <HeadingSmall
        title="Tu póliza actual"
        description="Información de tu seguro como asegurado principal"
      />

      <div class="my-4 grid w-95 grid-cols-2 gap-4">
        <LabelledItem label="Fecha de inicio" content="1/10/2026" />
        <LabelledItem label="Póliza" content="Adeslas Plan Total" />
        <LabelledItem label="Estado" content="1/10/2026" />
        <LabelledItem label="Coste empresa" content="Pagado por Comercia" />
      </div>
    </CardContent>
  </Card>
</template>
